var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.category)?_c('div',{class:['SBFaqTitleCategory','SBFaqTitle-' + _vm.category]},[_vm._v("\n        Q. "),_vm._t("default")],2):_c('div',{class:['SBFaqTitle']},[_vm._v("\n        Q. "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }